import { createContext } from "react";

import { InboxScreenHelper } from "./InboxScreenHelper.ts";

export const InboxScreenContext = createContext<InboxScreenHelper>(
  {} as InboxScreenHelper
);
